module.exports = __webpack_public_path__ + "img/thumb.cbdf1982.png";